import { _defineProperty } from "./index13.js";
import { ThreadData } from "./index54.js";
import { isPointInside, rayPolygonIntersection } from "@project-rouge/rg-three";
import { Vector3 } from "three";
var ThreadCollider = class {
	constructor(props) {
		_defineProperty(this, "data", void 0);
		this.data = new ThreadData(props);
	}
	getGrowLimit(forward) {
		const dir = forward ? this.data.dir : this.data.nDir;
		const sideHits = [];
		const sidePoints = forward ? this.data.sidePoints : this.data.sidePoints.slice().reverse();
		for (const start of sidePoints) {
			const hit = getClosestInsideHit(start, dir, this.data.boundary);
			if (!hit) return 0;
			sideHits.push(hit);
		}
		const hits = this.getPointsFromSideHits(sideHits);
		for (const start of sidePoints) for (const hole of this.data.holes) {
			const holeHit = getClosestInsideHit(start, dir, hole);
			if (holeHit) hits.push(holeHit.point);
		}
		let dist = Infinity;
		for (let i = 0; i < hits.length; i++) {
			const newDist = hits[i].sub(sidePoints[0]).dot(dir);
			if (dist < newDist) continue;
			dist = newDist;
		}
		return dist;
	}
	trimToMaxWingLength() {
		let size = this.data.size;
		if (this.data.isMain) size = Math.min(this.data.context.maxWingLength, size);
		else {
			var _this$data$startThrea;
			size = Math.min(this.data.context.maxWingLength - (((_this$data$startThrea = this.data.startThread) === null || _this$data$startThrea === void 0 ? void 0 : _this$data$startThrea.thread.depth) || 0), size);
		}
		if (size === this.data.size) return;
		const diff = this.data.size - size;
		let point = this.data.end;
		let dir = this.data.dir;
		if (this.data.tryTrimStart && !this.data.startThread) {
			point = this.data.start;
			dir = this.data.nDir;
		}
		point.addScaledVector(dir, -diff);
		this.data.updateSize();
	}
	isInsideHole() {
		for (const start of this.data.sidePoints) if (this.data.holes.some((poly) => isPointInside(start, poly))) return true;
		return false;
	}
	isInsideBoundary() {
		for (const start of this.data.sidePoints) if (!isPointInside(start, this.data.boundary)) return false;
		return true;
	}
	getPointsFromSideHits(sideHits) {
		const points = sideHits.map((hit) => hit.point);
		const lastEdge = sideHits[0].index <= sideHits[1].index ? sideHits[1].index : sideHits[1].index + this.data.boundary.length - 1;
		for (let i = sideHits[0].index; i < lastEdge; i++) {
			const boundaryPoint = this.data.boundary[(i + 1) % this.data.boundary.length];
			points.push(boundaryPoint.clone());
		}
		return points;
	}
};
var aStart = new Vector3();
function getClosestInsideHit(start, dir, polygon) {
	let hits = rayPolygonIntersection({
		polygon,
		ray: {
			start,
			dir
		},
		calculateEnters: false
	});
	hits = hits.filter((a) => {
		aStart.copy(a.point).sub(start);
		return (Math.sign(aStart.dot(dir)) || 1) === 1;
	});
	hits.sort((a, b) => {
		return a.point.distanceToSquared(start) - b.point.distanceToSquared(start);
	});
	return hits.at(0);
}
export { ThreadCollider };

//# sourceMappingURL=index55.js.map